/**
 * City slugs for /leaderboard/:countryCode/:citySlug — the backend has no slug field (only
 * id/name/country_id, see LeaderboardService's CityScope), so this is a client-side-only
 * convenience: slugify a city name for the URL, and match a URL slug back to a city by comparing
 * slugified names. Deliberately simple (no persistence, no collision handling) since city names
 * within one country are effectively unique in practice for this program's current scale.
 */
export function slugify(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip diacritics (Istanbul, İzmir, etc.)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}
